import ContentConfig from '../../config/ContentConfig';
import get10Data from '../../priming/get10Data';
import logger from '../../log';
import { setupDuration } from '../../common/utils/duration';
import { PrimingData } from '../../priming/interfaces';
import { Ecdn10Data } from '../../ecdn10/interfaces';
import hasAgentDataAnd10Agent from './hasAgentDataAnd10Agent';

const log = logger.getLogger(__filename);

const check10DataOrRetry = async (
  data: PrimingData,
  config: ContentConfig
): Promise<Ecdn10Data> => {
  let ecdn10 = data && data.ecdn10;
  if (ecdn10 && ecdn10.agentData && hasAgentDataAnd10Agent(ecdn10)) {
    return ecdn10 as Ecdn10Data;
  }
  const { vals } = setupDuration();
  const base = { doThrow: false, timeout: 2000 };
  ecdn10 = await get10Data({ base, config, vals });
  log.info(`Trying to get 10 agent data. Took ${vals.durs[10]} ms`);
  return ecdn10 as Ecdn10Data;
};
export default check10DataOrRetry;
